import { Calculator } from "./calculator";
import { Admin } from "./admin";
import Auth from "./auth";
import NodeEditor from './nodeEditor';

export default {
  Auth,
  Calculator,
  Admin,
  NodeEditor,
};
